var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.innerPages.includes(this.$route.meta.title))?_c('innerPage'):_c('outerPage')}
var staticRenderFns = []

export { render, staticRenderFns }